export default __webpack_public_path__ + "static/media/AJMA.9fbd0b0d.png";